import { render, staticRenderFns } from "./bids.vue?vue&type=template&id=4073785c&scoped=true"
import script from "./bids.vue?vue&type=script&lang=ts"
export * from "./bids.vue?vue&type=script&lang=ts"
import style0 from "./styles/scoped.scss?vue&type=style&index=0&id=4073785c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073785c",
  null
  
)

export default component.exports